export enum ROLE {
    Admin = 'admin',
    Candidate = 'candidate',
  }